export async function fileToBase64(file: File, chunkSize: number = 8192): Promise<string> {
    return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
            const arrayBuffer = reader.result as ArrayBuffer;
            const uint8Array = new Uint8Array(arrayBuffer);

            let binaryString = '';
            for (let i = 0; i < uint8Array.length; i += chunkSize) {
                const chunk = uint8Array.subarray(i, Math.min(i + chunkSize, uint8Array.length));
                const chunkArray = Array.from(chunk);
                binaryString += String.fromCharCode.apply(null, chunkArray as any);
            }

            const base64String = btoa(binaryString);
            resolve(base64String);
        };

        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
    });
}

export async function fileToTranslateFileData(
    file: File,
    index: number
): Promise<{
    id: string;
    name: string;
    size: number;
    type: string;
    content: string;
}> {
    const base64Content = await fileToBase64(file);

    return {
        id: `${file.name}_${Date.now()}_${index}`,
        name: file.name,
        size: file.size,
        type: file.type,
        content: base64Content
    };
}
